import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Messenger = _resolveComponent("Messenger")!
  const _component_Launcher = _resolveComponent("Launcher")!

  return (_ctx.isReady)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Messenger, {
          "is-open": _ctx.delayedIsWidgetOpen,
          onMinimize: _ctx.notifyCloseWidget
        }, null, 8, ["is-open", "onMinimize"]),
        _createVNode(_component_Launcher, {
          "is-open": _ctx.delayedIsWidgetOpen,
          onOpen: _ctx.notifyOpenWidget,
          onClose: _ctx.notifyCloseWidget
        }, null, 8, ["is-open", "onOpen", "onClose"])
      ]))
    : _createCommentVNode("", true)
}